import Database from "../../database";
import { Storage } from "../../utils";
import { DATABASE_TABLES } from "../constants";

export async function saveNotificationsDeviceToken(token) {
  try {
    const user = Storage.get("usuario", true);
    const tokenDB = await Database.getItem(
      DATABASE_TABLES.NOTIFICATIONS_TOKENS,
      "token",
      token
    );
    console.log(token);
    // GUARDAR TOKEN SI NO EXISTE
    if (tokenDB === null) {
      await Database.save(DATABASE_TABLES.NOTIFICATIONS_TOKENS, {
        userId: user.usuario,
        token,
      });
    }
  } catch (error) {
    throw new Error(error);
  }
}
